import { render, staticRenderFns } from "./Byyw.vue?vue&type=template&id=232a72ca&"
import script from "./Byyw.vue?vue&type=script&lang=js&"
export * from "./Byyw.vue?vue&type=script&lang=js&"
import style0 from "./Byyw.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports